import { Component, ContentChild, Input, Output, OnInit, OnDestroy, TemplateRef } from '@angular/core';

import { Observable ,  Subscription } from 'rxjs';

import { AnimationService } from '../../services/animation/animation.service';
import { PaginatedAsyncState } from '../../../../interfaces/store.interface';

import { CONFIG } from '../../config/config.const';

@Component({
    selector: 'app-paginated',
    templateUrl: './paginated.component.html',
    styleUrls: ['./paginated.component.scss'],
    animations: [
        AnimationService.fadeInOutFixed()
    ]
})
export class PaginatedComponent implements OnDestroy, OnInit {

    @Input() data: Observable<PaginatedAsyncState>;
    @Input() type: string;

    @ContentChild(TemplateRef, {static: false}) listingTemplate: TemplateRef<any>;

    state: PaginatedAsyncState;
    subscription: Subscription;

    removedFlag = CONFIG.PAGINATION.REMOVED_FLAG;

    ngOnInit () {
        this.subscription = this.data.subscribe((data: PaginatedAsyncState) => {
            this.state = data;
        });
    }

    ngOnDestroy () {
        this.subscription.unsubscribe();
    }

}
